import React, { useEffect, useState } from "react"
import closeIcon from "@/public/icons/close.svg"
import pdfIcon from "@/public/icons/pdf-grey.svg"

const ImageUploadView = props => {
  const [imageInfo, setImageInfo] = useState({
    url: "",
    comment: "",
  })

  useEffect(() => {
    setImageInfo({
      ...imageInfo,
      url: props.url ?? "",
      comment: props.comment ?? "",
    })
  }, [props.url, props.comment])

  useEffect(() => {
    if (props.uploadedImage.length > 0 && imageInfo.comment !== "") {
      let uploadedImage = props.uploadedImage.map((data, index) => {
        if (props.index === index) {
          return Object.assign(data, { comment: imageInfo.comment })
        } else {
          return data
        }
      })
      props.setUploadedImage(uploadedImage)
    }
  }, [imageInfo])

  const handleClose = (e, index) => {
    e.stopPropagation()
    let path = [...props.path]
    let pathIndex = path.indexOf(props.url)
    path.splice(pathIndex, 1)

    let uploads = [...props.uploadedImage]
    let paths = uploads.map(file => {
      return file.url
    })
    let uploadIndex = paths.indexOf(props.file.preview)
    uploads.splice(index, 1)

    props.setUploadedImage(uploads)
    props.setPath(path)
    props.addCount(props.fileCount + 1)
    props.clearErrorMsg("")
    props.handleUploader(false)
    props.setClear(true)
  }

  const getAddProductCloseAnalytics = () => {
    return JSON.stringify({
      clickInternalLinks: "true",
      eventAction:
        "my account:register offline kohler products:product information:remove uploaded product image",
      eventName:
        "my account:register offline kohler products:product information:remove uploaded product image",
      eventType: "informative",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: "remove uploaded product image",
      internalLinkPosition: "register offline kohler products",
      internalLinkType: "my account:navigation",
      internalLinkZoneName:
        "my account:register offline kohler products:product information",
      internalLinkURL: "n/a",
    })
  }

  const fileSizeConverter = data => {
    let size = parseInt(data)
    for (let unit of ["b", "Kb", "Mb", "Gb"]) {
      if (size < 1024) return `${size.toFixed(2)} ${unit}`
      size /= 1024.0
    }
  }

  return (
    <div className={`image-preview`}>
      <span
        className="image-delete gbh-data-layer"
        data-gbh-data-layer={getAddProductCloseAnalytics()}
      >
        <img
          src={closeIcon.src}
          alt="close"
          tabIndex="0"
          onClick={e => handleClose(e, props.index)}
          aria-controls="planetInfo"
        />
      </span>
      <div className="image-preview-container">
        <div className="image-uploaded">
          <div className={"image-uploaded__preview-container"}>
            <div className={"image-uploaded__preview-inner-container"}>
              {props.file.type === "application/pdf" ? (
                <img src={pdfIcon.src} className={"image-uploaded__image"} />
              ) : (
                <img
                  src={props.file.preview}
                  className={"image-uploaded__image"}
                />
              )}
            </div>
          </div>
        </div>
        <div className="image-description">
          <p>{props?.file?.path}</p>
          <p>{fileSizeConverter(props?.file?.size)}</p>
        </div>
      </div>
    </div>
  )
}

export default ImageUploadView
